export default __webpack_public_path__ + "static/media/cpv_60_transport.2e97d6b1.svg";